import { render, staticRenderFns } from "./menu_button.vue?vue&type=template&id=7de84e2e&scoped=true&"
import script from "./menu_button.vue?vue&type=script&lang=js&"
export * from "./menu_button.vue?vue&type=script&lang=js&"
import style0 from "./menu_button.vue?vue&type=style&index=0&id=7de84e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de84e2e",
  null
  
)

export default component.exports